export const KIT_VERSION = "26f9656d";
